module.exports = __webpack_public_path__ + "img/2021_1_31_skull_CAT.06a70d53.jpg";